export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Local development configuration
export const BYPASS_AUTH = process.env.REACT_APP_BYPASS_AUTH === 'true';
export const LOCAL_USER_EMAIL = process.env.REACT_APP_LOCAL_USER_EMAIL || 'dev@teamray.local';
export const LOCAL_USER_NAME = process.env.REACT_APP_LOCAL_USER_NAME || 'Local Developer';
export const LOCAL_USER_ROLE = process.env.REACT_APP_LOCAL_USER_ROLE || 'Admin';